





















import { Component } from 'vue-property-decorator'
import { EliteligaDashboard } from '@russmedia-frontend/nordstern-eliteliga'
import VNEliteliga from '~components/assets/VNEliteliga.vue'
import { ApolloOperationVariables } from '~base/common/types'
import EliteligaFeature from '~base/mixins/EliteligaFeature'
import VideoModal from '~components/eliteliga/VideoModal.vue'

import '@russmedia-frontend/nordstern-eliteliga/nordstern-eliteliga.css'

@Component({
  components: {
    VNEliteliga,
    EliteligaDashboard,
    VideoModal,
  },
  apollo: {
    multileague: {
      query: require('~base/graphql/queries/SoccerLeague.gql'),
      prefetch(): ApolloOperationVariables {
        return {
          leagues: this.leagues,
        }
      },
      variables(): ApolloOperationVariables {
        return {
          leagues: this.leagues,
        }
      },
    },
  },
})
export default class EliteLiga extends EliteligaFeature {}
